import type { ColumnDef } from '@tanstack/react-table';
import { Check, X } from 'lucide-react';
import { Button, Dialog, ManagedDataTable } from '@/design-system';
import type { ModulePackage } from '@/features/modules';
import type { LicensingCatalog, PlanTier } from '../api/plan-licensing.service';

const tiers: PlanTier[] = ['lite', 'pro', 'ultra'];
const labels = { lite: 'Lite', pro: 'Pro', ultra: 'Ultra' };
type Capability = LicensingCatalog['capabilities'][number];

export function PackageComparisonDialog({ isOpen, onClose, packages, catalog }: {
  isOpen: boolean; onClose: () => void; packages: ModulePackage[]; catalog: LicensingCatalog;
}) {
  const selected = tiers.map((tier) => packages.find((item) => item.tier === tier && item.name.replace(/\s*[·—-]\s*pacote\s*$/i, '').toLowerCase() === tier) ?? packages.find((item) => item.tier === tier));
  const columns: ColumnDef<Capability>[] = [
    { accessorKey: 'name', header: 'Recurso', enableSorting: false, minSize: 240 },
    ...tiers.map((tier, index): ColumnDef<Capability> => ({
      id: tier, header: labels[tier], enableSorting: false,
      cell: ({ row }) => {
        const item = selected[index];
        const included = item?.capabilityKeys.includes(row.original.key);
        return <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium ${!item ? 'bg-slate-100 text-slate-600' : included ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
          {item && (included ? <Check aria-hidden="true" className="h-3 w-3" /> : <X aria-hidden="true" className="h-3 w-3" />)}
          {!item ? 'Não cadastrado' : included ? 'Incluído' : 'Não incluído'}
        </span>;
      },
    })),
  ];
  return <Dialog isOpen={isOpen} onClose={onClose} title="Comparativo dos pacotes" size="xl" footer={(
    <Button variant="subtle" onClick={onClose}>Fechar comparativo</Button>
  )}>
    <div className="space-y-4">
      <p className="text-sm text-gray-600">Recursos da configuração atual de Lite, Pro e Ultra. Preços e condições são definidos no plano comercial.</p>
      <ManagedDataTable appearance="embedded" columns={columns} data={catalog.capabilities.filter((capability) => capability.key !== 'allow_ai')} disableSearch showPagination={false} getRowId={(row) => row.key} stickyHeader maxHeight="min(55vh, 480px)" />
    </div>
  </Dialog>;
}
